export const modalStyles = {
  display: "flex",
  flexDirection: "row",
  minHeight: 0,
  padding: 0,
};
